import { useMemo } from 'react';
import type { EmployeeRecordT } from '@lotushealth/lotushealth_js_sdk/schemas';

import { useZodForm } from '@/shared/lib/forms';

import {
  demographicInfoFormSchema,
  type DemographicInfoFormValues,
} from './demographic-info-schema';
import { demographicDefaultsFromEmployeeRecord } from './employee-record-prefill';
import { createQaDemographicInfoDefault, isQaFixtureActive } from './qa-dosespot-fixtures';

interface UseDemographicInfoFormOptions {
  employeeRecord?: EmployeeRecordT | null;
}

export function useDemographicInfoForm(options: UseDemographicInfoFormOptions = {}) {
  const { employeeRecord } = options;

  const defaultValues = useMemo<DemographicInfoFormValues>(() => {
    if (isQaFixtureActive()) {
      return { demographicInfo: createQaDemographicInfoDefault() };
    }
    if (employeeRecord) {
      return { demographicInfo: demographicDefaultsFromEmployeeRecord(employeeRecord) };
    }
    return { demographicInfo: createQaDemographicInfoDefault() };
  }, [employeeRecord]);

  return useZodForm<DemographicInfoFormValues>({
    schema: demographicInfoFormSchema,
    defaultValues,
    resetOnDefaultsChange: true,
  });
}
